import { z } from 'zod';

import { PaginationSchema } from '../../../pagination.js';

export const WorkshopTaxonomyOriginSchema = z.enum(['ZR', 'CUSTOM']);
export type WorkshopTaxonomyOrigin = z.infer<typeof WorkshopTaxonomyOriginSchema>;

const WorkshopTaxonomyListQuerySchema = PaginationSchema.extend({
  q: z.string().trim().min(2).optional(),
  limit: z.coerce.number().int().min(1).max(500).default(20),
});

const taxonomySlug = z
  .string()
  .trim()
  .min(1)
  .max(100)
  .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/);

export const RegisterManufacturerBodySchema = z.object({
  name: z.string().trim().min(1).max(255),
  slug: taxonomySlug,
});

export const RegisterManufacturerResponseSchema = z.object({
  manufacturerId: z.uuid(),
});

export const UpdateManufacturerBodySchema = z
  .object({
    name: z.string().trim().min(1).max(255).optional(),
    slug: taxonomySlug.optional(),
  })
  .refine((body) => Object.keys(body).length > 0, { message: 'At least one field is required' });

export const ArchiveManufacturerBodySchema = z.object({
  reason: z.string().trim().max(500).optional(),
});

export const ListManufacturersQuerySchema = WorkshopTaxonomyListQuerySchema;

export const ManufacturerListItemSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  slug: z.string(),
  origin: WorkshopTaxonomyOriginSchema,
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});

export const ListManufacturersResponseSchema = z.object({
  items: z.array(ManufacturerListItemSchema),
  pagination: z.object({
    cursor: z.string().nullable(),
    hasMore: z.boolean(),
  }),
});

export type RegisterManufacturerBody = z.infer<typeof RegisterManufacturerBodySchema>;
export type RegisterManufacturerResponse = z.infer<typeof RegisterManufacturerResponseSchema>;
export type UpdateManufacturerBody = z.infer<typeof UpdateManufacturerBodySchema>;
export type ArchiveManufacturerBody = z.infer<typeof ArchiveManufacturerBodySchema>;
export type ListManufacturersQuery = z.infer<typeof ListManufacturersQuerySchema>;
export type ListManufacturersResponse = z.infer<typeof ListManufacturersResponseSchema>;
